import PropTypes from 'prop-types'
import React, { memo } from 'react'
import { Alert } from 'react-bootstrap'
import { FormattedMessage } from 'react-intl'
import { formatBoldChunks } from '../../../../../util/message.util'

const propTypes = {
  /**
   * Custom authentication strength that could not be carried onto the template.
   */
  authenticationStrength: PropTypes.shape({
    id: PropTypes.string,
    displayName: PropTypes.string,
  }),
}

function UnsupportedAuthenticationStrengthAlert({ authenticationStrength = null }) {
  const displayName = authenticationStrength?.displayName || authenticationStrength?.id
  if (!displayName) {
    return null
  }

  return (
    <Alert variant="warning" className="text-color-default d-flex align-items-baseline mb-4">
      <i className="fas fa-triangle-exclamation me-2" />
      <div>
        <FormattedMessage
          id="POLICY_TEMPLATES.UNSUPPORTED_AUTHENTICATION_STRENGTH"
          values={{ b: formatBoldChunks, displayName }}
        />
      </div>
    </Alert>
  )
}

UnsupportedAuthenticationStrengthAlert.propTypes = propTypes

export default memo(UnsupportedAuthenticationStrengthAlert)
